"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSchedulingMatrixLegendFooter = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const View_1 = require("../View");
const FillCircle = (0, styled_components_1.default)(View_1.View) `
    width: ${helpers_1.SIZE_M};
    height: ${helpers_1.SIZE_M};
    border-radius: 50%;
`;
const Wrapper = (0, styled_components_1.default)(StackView_1.StackView) `
    margin-top: -${helpers_1.SPACING_M};
`;
const createSchedulingMatrixLegendFooter = ({ texts }) => ({
    render: () => (react_1.default.createElement(Wrapper, { gap: StackView_1.STACK_GAP.m, align: StackView_1.STACK_ALIGN.center },
        (texts === null || texts === void 0 ? void 0 : texts.label) && react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.s }, texts === null || texts === void 0 ? void 0 : texts.label),
        react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.center },
            react_1.default.createElement(FillCircle, { backgroundView: View_1.VIEW_BG_VIEW.highlightDark }),
            react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.s }, (texts === null || texts === void 0 ? void 0 : texts.selectMode) || 'Permitted')),
        react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.center },
            react_1.default.createElement(FillCircle, { backgroundView: View_1.VIEW_BG_VIEW.highlightDarkInverted }),
            react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.s }, (texts === null || texts === void 0 ? void 0 : texts.unselectMode) || 'Denied'))))
});
exports.createSchedulingMatrixLegendFooter = createSchedulingMatrixLegendFooter;
//# sourceMappingURL=legendFooter.js.map